export default {
  main: {
    title: '버전 확인',
    language: '한국어',
    intro:
      '버전 확인은 버전 간의 MD5 또는 SHA256 해시 값을 일치시킴으로써 수행됩니다. 사기를 피하기 위해 공식 채널을 통해 TokenPocket 지갑을 다운로드하는 것을 확인해주세요. 버전의 MD5 또는 SHA256 해시 값을 얻는 방법에 대한 안내는 ',
    tutorial: '튜토리얼을 참조하세요 >',
    system: '운영체제',
    android: '안드로이드',
    ios: 'iOS',
    version: '버전',
    allVersion: '전체',
    appChannel: '앱 채널',
    developer: '개발자',
    allChannel: '전체',
    md5: 'MD5',
    sha256: 'SHA256',
    log: '버전 로그',
    check: '자세히 보기',
    versionLog: '버전 로그',
    confirm: '확인',
    aboutIOS: 'iOS 버전 정보',
    IOSDesc:
      'iOS 버전의 경우, 저희 앱은 App Store에서만 제공됩니다. App Store에서 다운로드한 앱만 올바르게 설치됩니다. 따라서 애플 기기를 사용할 때, 다운로드 채널로 App Store를 인증하도록 해주세요.',
    IOSDesc_2:
      '2022년 10월 8일 이전에 App Store에서 다운로드한 버전의 개발자는 TOKENPOCKET FOUNDATION LTD입니다. 이는 TokenPocket에서 개발한 초기 버전으로 정식 지갑으로 정상적으로 사용할 수 있으나, 업데이트 서비스가 일시적으로 중단됩니다.',
    aboutAndroid: '안드로이드 버전 정보',
    androidDesc: '현재 TokenPocket의 Android 다운로드 채널은 공식 웹사이트, Google Play 스토어, 삼성 앱스토어, Huawei 앱 갤러리, OPPO 앱스토어, Vivo 앱스토어를 포함합니다. 일부 앱스토어에서는 다운로드 과정에서 APK 설치 파일을 얻을 수 없기 때문에 MD5 또는 SHA256 계산 검증을 수행할 수 없습니다. 따라서 다운로드할 때 개발자 정보를 명확히 확인하고 아래를 참조하시기 바랍니다!',
    IOSAppName: '애플리케이션 이름:',
    TPWallet: 'TP Wallet',
    AppIcon: '애플리케이션 아이콘:',
    AppDeveloper: '개발자:',
    downloadLink: '다운로드 링크:',
    copied: '복사되었습니다!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: '우리를 따라오세요',
    desc1: 'TokenPocket 직원은 개인 메시지를 보내지 않습니다!',
    desc2:
      '주의! TokenPocket 커뮤니티에 참여 중입니다. 누군가 우리를 사칭하여 개인 메시지를 보낼 수 있습니다! 개인 메시지를 보내는 사람은 모두 사기꾼일 수 있다는 점에 유의하세요! 우리는 당신에게 먼저 연락하지 않을 것입니다!',
    desc3: '이해, 입력',
  },
  COMMON: {
    LAYOUT: {
      features: '기능',
      products: '제품',
      buyCryptoFooter: '암호화폐 구매',
      mobileWallet: '모바일 지갑',
      mobileWalletDesc: '블록체인 기반 암호화폐 & DeFi 모바일 지갑.',
      hardwareWallet: '하드웨어 지갑',
      hardwareWalletDesc: 'KeyPal로 자산을 보호하세요.',
      extensionWallet: '익스텐션 지갑',
      extensionWalletDesc: '컴퓨터에서 더 나은 지갑 사용.',
      desktop: '데스크탑 지갑',
      fiveDegrees: '5Degrees',
      versionVerification: '버전 검증',
      versionVerificationDesc: '지갑을 검증하세요.',
      approvalDetector: '승인 탐지기',
      approvalDetectorDesc: '승인된 토큰 보기 및 승인 해제.',
      tokenSecurity: '토큰 보안',
      tokenSecurityDesc: '토큰의 계약 주소를 통해 보안을 확인하세요.',
      keyGenerator: '키 생성기',
      keyGeneratorDesc: '여러 네트워크를 위한 퍼블릭 및 프라이빗 키 무작위 생성.',
      tokenProfile: '토큰 프로필',
      tokenProfileDesc: '토큰에 대한 모든 정보 알아보기.',
      tokenClaim: '토큰 청구',
      tokenClaimDesc: '에어드랍 청구.',
      easyInscription: '간편한 인스크립션',
      easyInscriptionDesc: '안전한 인스크립션 도구.',
      nostrAssetsBatchSender: 'NostrAssets 일괄 전송',
      nostrAssetsBatchSenderDesc: 'NostrAssets용 일괄 전송 도구.',
      BATCH_SENDER: '일괄 전송',
      BATCH_SENDER_DESC: '한 번에 여러 수신자에게 토큰 전송.',
  
      trade: '거래',
      swap: '트랜짓 스왑',
      swapDesc: '최상의 가격으로 스왑',
      bridge: 'Bridge',
      bridgeDesc: 'Ensuring seamless asset liquidity.',
      buyCrypto: '구매',
      buyCryptoDesc: '신용카드로 암호화폐 구매.',
      market: '마켓',
      marketDesc: '실시간 인사이트 인기 토큰 확인.',
  
      information: '정보',
      blockchainGuide: 'Blockchain 지갑 가이드라인',
      tronWallet: 'TRON 지갑 가이드라인',
      iostWallet: 'IOST 지갑 가이드라인',
      tpMan: 'TP 맨',
  
      developers: '개발자',
      github: 'Github (TP-Lab)',
      devCenter: '개발자 센터',
      developersDesc: '토큰포켓 개발자 문서.',
      subToken: '토큰 제출',
      subTokenDesc: '토큰 제출.',
      subDApp: 'DApp 제출',
      subDAppDesc: 'DApp 제출 검토 후 표시.',
      subNFT: 'NFT 제출',
      subNFTDesc: 'NFT 및 예술 작품 제출.',
      subChain: '체인 제출',
      subChainDesc: '블록체인 제출.',
      bugBounty: '버그 바운티',
  
      tools: '도구',
  
      build: '빌드',
  
      learn: 'Learn',
  
      explorer: 'Explorer',
  
      company: '회사',
      about: '에 대한',
      careers: '직업',
      pressKit: '브랜드 키트',
      swagShop: '스웨그 샵',
  
      support: '서포트',
      helpCenter: '도움 센터',
      helpCenterDesc: '답변과 지원을 위한 리소스.',
      contactUs: '문의하기',
      contactUsDesc: '제안 공유 및 질문.',
      forum: '포럼',
      forumDesc: '커뮤니티 회원들과의 대화.',
  
      legal: '법률',
      privacyPolicy: '개인 정보 보호 정책',
      terms: '이용 약관',
  
      toHome: '홈',
      defiWallet: 'DeFi 지갑',
      ETHWallet: '이더리움 지갑',
      ethWallet: 'eth 지갑',

      dappStore: 'DApp 스토어',
    }
  }
};
